angular.module('visualChooseModule', [])
.controller('name', ['visualChooseCtrl', function(){
	
}]);